module.exports = __webpack_public_path__ + "img/source_book-item11.0e3fb093.png";